import React, { useState, useEffect, useCallback } from "react";
import { Link, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import toggleNavigation from "theme/dom/toggleNavigation";
import Icon from "theme/Icon";
import Button from "theme/Button";
import HeaderButton from "./HeaderButton";
import { checkAuthSession, objectSelector } from "theme/utils";
import SubModal from "theme/SubModal";

const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);
const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/navigation`);
const $STP = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/product`);

const Logo = React.lazy(() => import("./Logo"));

const Header = ({ classes, location }) => {
  const customer = useSelector((state) => state.customerDetail.customer);
  const currentStaff = useSelector((state) => state.staffs.currentStaff);
  const basketItems = useSelector((state) => state.basket.basketItems);

  const [headerControl, setHeaderControl] = useState(true);
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false);
  const [logoutRedirect, setLogoutRedirect] = useState(false);
  const isAuthenticated = checkAuthSession();

  const conditions = ["store-selection", "login", "staff-selection"];
  const IS_CHECK_AUTH_BRAND = $A.BRAND === "Koton" || $A.BRAND === "TFS";

  const getlocalCurrentStaff = useCallback(
    () =>
      (localStorage.getItem("usedStorage") !== undefined &&
        localStorage.getItem("usedStorage") !== "undefined" &&
        JSON.parse(localStorage.getItem("usedStorage"))) ||
      {},
    []
  );

  useEffect(() => {
    const isCondition = conditions.some((path) =>
      location.pathname.includes(path)
    );

    if (!isCondition) {
      setHeaderControl(false);
    }
  }, [location.pathname, conditions]);

  useEffect(() => {
    const isCondition = conditions.some((path) =>
      location.pathname.includes(path)
    );

    if (
      !isCondition &&
      !isAuthenticated &&
      Object.keys(currentStaff).length === 0
    ) {
      setHeaderControl(
        !isAuthenticated && IS_CHECK_AUTH_BRAND ? true : isCondition
      );
      setSessionExpiredModal(
        !isAuthenticated && IS_CHECK_AUTH_BRAND ? true : false
      );
    }
  }, [
    location.pathname,
    conditions,
    IS_CHECK_AUTH_BRAND,
    isAuthenticated,
    currentStaff,
  ]);

  let localBaskedItemData = JSON.parse(localStorage.getItem("localBaskedItem"));
  let localBaskedItem =
    localBaskedItemData !== null &&
    localBaskedItemData !== undefined &&
    localBaskedItemData.basket.basketitem_set !== undefined &&
    localBaskedItemData.basket.basketitem_set.length > 0 &&
    localBaskedItemData.basket.basketitem_set[0].quantity;

  const localCurrentStaff = localStorage.getItem("localCurrentStaff");

  const localCurrentStaffControl =
    !!localCurrentStaff &&
    localCurrentStaff !== "null" &&
    localCurrentStaff !== "undefined";

  let count = 0;

  let staff_id =
    currentStaff !== undefined && currentStaff.id !== undefined
      ? currentStaff.id
      : localStorage.getItem("localCurrentStaff");

  if (basketItems !== undefined && basketItems.length > 0) {
    basketItems.forEach((item) => {
      count = count + item.quantity;
    });
  } else if (
    localBaskedItemData !== null &&
    localBaskedItemData !== "null" &&
    localBaskedItemData.basket.basketitem_set.length === 0
  ) {
    count = 0;
  } else if (
    localBaskedItem !== "null" &&
    localBaskedItem !== undefined &&
    localBaskedItem !== null
  ) {
    count = localBaskedItem;
  }

  const IS_SAMSUNG = $A.BRAND === "SAMSUNG";
  const IS_CMC = getlocalCurrentStaff().name === "CMC";
  const IS_TFS = $A.BRAND === "TFS";

  const btnConditions = {
    search: IS_SAMSUNG
      ? IS_CMC && $R.PRODUCT_SEARCH.active
      : $R.PRODUCT_SEARCH.active,
    basket: IS_SAMSUNG ? IS_CMC && $R.BASKET.active : $R.BASKET.active,
    staff: IS_SAMSUNG
      ? IS_CMC && $R.CUSTOMER_LIST.active
      : $R.CUSTOMER_LIST.active,
  };

  const currentStore = JSON.parse(localStorage.getItem("popularStore"));
  const currentStoreName = objectSelector(currentStore, "name") || "";

  if (logoutRedirect) {
    return <Redirect to="/store-selection" />;
  }

  return (
    <React.Fragment>
      <React.Suspense fallback={<span />}>
        {sessionExpiredModal && IS_CHECK_AUTH_BRAND && (
          <SubModal
            classes="text-center inner-centered modal-column"
            onClose={() => setLogoutRedirect(true)}
            buttonText={$STP.OKAY}
            style={{ maxWidth: "400px", paddingBottom: "30px" }}
          >
            <p
              style={{
                color: "#000",
                paddingTop: "30px",
                paddingBottom: "30px",
              }}
            >
              {$ST.SESSION_EXPIRED}
            </p>
          </SubModal>
        )}
        <header id="js-header-logo" className={classes}>
          <Link
            to={headerControl ? "/store-selection" : $R.MAIN_HOME.path}
            className={staff_id ? "header-logo notAlone" : "-logo"}
          >
            <Logo />
          </Link>
        </header>
        {headerControl === false && localCurrentStaffControl === true && (
          <header id="js-header" className={classes}>
            {(currentStaff.id || localCurrentStaffControl) && (
              <div className="wrapper">
                <HeaderButton classes="menuWrapper">
                  <Button onClick={() => toggleNavigation()}>
                    <Icon icon="menu" />
                  </Button>
                </HeaderButton>
                {IS_TFS && (
                  <div
                    style={{
                      color: "black",
                      display: "flex",
                      alignItems: "center",
                      marginRight: "16px",
                    }}
                  >
                    {currentStoreName}
                  </div>
                )}
                <div style={{ position: "relative" }}>
                  {!!customer.pk && (
                    <HeaderButton classes="header-item right">
                      <Link
                        to={{
                          pathname: $R.CUSTOMER_LIST.path,
                          state: { keepBasket: !!customer.pk },
                        }}
                      >
                        <Icon icon="profil" />
                        {customer.first_name && (
                          <span className="customer">
                            {`${customer.first_name || ""} ${
                              customer.last_name || ""
                            }`}
                          </span>
                        )}
                      </Link>
                    </HeaderButton>
                  )}
                  {btnConditions.search && (
                    <HeaderButton classes="header-item right">
                      <Link to={$R.PRODUCT_SEARCH.path}>
                        <Icon icon="arama" />
                      </Link>
                    </HeaderButton>
                  )}
                  {btnConditions.basket && (
                    <HeaderButton classes="header-item right">
                      <Link to={$R.BASKET.path}>
                        <div className="basket-icon-container">
                          <Icon icon="sepet" />
                          {!!count && <span className="count">{count}</span>}
                        </div>
                      </Link>
                    </HeaderButton>
                  )}
                  {btnConditions.staff && (
                    <HeaderButton classes="header-item right full plus">
                      <Link
                        to={{
                          pathname: $R.CUSTOMER_LIST.path,
                          state: { keepBasket: true },
                        }}
                      >
                        <Icon icon="arti" />
                      </Link>
                    </HeaderButton>
                  )}
                </div>
              </div>
            )}
            <Link
              to={headerControl ? "/store-selection" : $R.MAIN_HOME.path}
              className={staff_id ? "header-logo notAlone" : "-logo"}
            >
              <Logo />
            </Link>
          </header>
        )}
      </React.Suspense>
    </React.Fragment>
  );
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/partials/Header.js